export const ORG_ID_PARAM = 'orgId';

export function getShareableLink(url: string, orgId: string): string {
  const isRelative = url.startsWith('/');
  const parsedUrl = isRelative
    ? new URL(url, 'https://placeholder.invalid')
    : new URL(url);
  parsedUrl.searchParams.set(ORG_ID_PARAM, orgId);
  return isRelative
    ? `${parsedUrl.pathname}${parsedUrl.search}`
    : parsedUrl.toString();
}

export function getShareableLinkFromCurrentUrl(orgId: string): string {
  return getShareableLink(window.location.href, orgId);
}
